import React, { forwardRef } from 'react';

import { FormControl, FormHelperText, FormLabel, Input, useTheme } from '@mui/joy';
import { SxProps } from '@mui/system';

interface Props {
  label: string;
  name: string;
  placeholder?: string;
  error?: string;
  value?: string;
  type?: string;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  classNames?: string;
  required?: boolean;
  autocomplete?: string;
  sx?: SxProps;
}

export const TextInputField = forwardRef<HTMLInputElement, Props>(
  (
    {
      label,
      name,
      placeholder,
      error,
      value,
      type,
      disabled = false,
      required = false,
      onChange,
      classNames,
      autocomplete,
      sx
    },
    ref
  ) => {
    const theme = useTheme();
    return (
      <FormControl className='mb-4' error={!!error} ref={ref} required={required}>
        <FormLabel style={{ color: disabled ? theme.palette.neutral[400] : '' }}>{label}</FormLabel>
        <Input
          autoComplete={autocomplete || 'off'}
          className={classNames}
          disabled={disabled}
          id={name}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          ref={ref}
          sx={sx}
          type={type}
          value={value}
        />
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    );
  }
);

TextInputField.displayName = 'TextInputField';
